exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2s732sSG19U3rzgiMcRM6{font-size:12px;font-weight:400}html[dir] ._2s732sSG19U3rzgiMcRM6{padding:0}.Q0mpXNL86uxDXVclYqguR{height:24px}html[dir] .Q0mpXNL86uxDXVclYqguR{margin-top:8px}._1BRcvaxu_Y9lmlPavDCX2H{height:24px}html[dir] ._1BRcvaxu_Y9lmlPavDCX2H{margin-top:8px}html[dir=ltr] ._1BRcvaxu_Y9lmlPavDCX2H{margin-right:8px}html[dir=rtl] ._1BRcvaxu_Y9lmlPavDCX2H{margin-left:8px}", ""]);
// Exports
exports.locals = {
	"errorLabel": "_2s732sSG19U3rzgiMcRM6",
	"reconnectButton": "Q0mpXNL86uxDXVclYqguR",
	"removeButton": "_1BRcvaxu_Y9lmlPavDCX2H"
};